import PropTypes from "prop-types";

import styles from "./styles.module.css";

const TextArea = ({ errorMessage, placeholder, rowNumber, ...props }) => {
  return (
    <div className={styles.wrapper}>
      <textarea rows={rowNumber} placeholder={placeholder} {...props}></textarea>
      {errorMessage && <span className={styles.errorMessage}>{errorMessage}</span>}
    </div>
  );
};

TextArea.propTypes = {
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  rowNumber: PropTypes.number,
};

export default TextArea;
